<template>
  <div class="container" v-if="$route.name!='maintenance'">
    <div class="columns is-multiline">
      <div class="column" :class="cookies_facebook ? 'is-4' : 'is-6'">
        <p class="title">Unser Angebot</p>
        <p>Mit einer Veranstaltung, der eigenen Unterkunft oder dem eigenen Restaurant auf www.urlaubimwaldviertel.at vertreten sein? Kein Problem, setzten Sie sich mit uns in Verbindung, wir freuen uns von Ihnen zu hören!</p>
        <p style="margin-top:20px;">
          <router-link class="button is-medium is-info" to="/unser-angebot">
            <span class="icon">
              <i class="fa fa-child"></i>
            </span>
            <span>Erfahren Sie mehr</span>
          </router-link>
        </p>
      </div>

      <div class="column" :class="cookies_facebook ? 'is-4' : 'is-6'">
        <p class="title">Auf einen Blick</p>
        <div class="tags">
          <span
            @click="$router.push('/abenteuer')"
            class="tag is-link is-medium is-rounded cursor"
          >Abenteuer</span>
          <span
            class="tag is-link is-medium is-rounded cursor"
            @click="$router.push('/ausflugsziele')"
          >Ausflugsziele</span>
          <span class="tag is-link is-medium is-rounded cursor" @click="$router.push('/bio')">Bio</span>
          <span
            class="tag is-link is-medium is-rounded cursor"
            @click="$router.push('/einkaufen')"
          >Einkaufen</span>
          <span
            class="tag is-link is-medium is-rounded cursor"
            @click="$router.push('/gasthaeuser')"
          >Gasthäuser</span>
          <span
            class="tag is-link is-medium is-rounded cursor"
            @click="$router.push('/heurige')"
          >Heurige</span>
          <span
            class="tag is-link is-medium is-rounded cursor"
            @click="$router.push('/hotels')"
          >Hotels</span>
          <span
            class="tag is-link is-medium is-rounded cursor"
            @click="$router.push('/kaffeehaeuser')"
          >Kaffeehäuser</span>
          <span
            class="tag is-link is-medium is-rounded cursor"
            @click="$router.push('/kulinarium')"
          >Kulinarium</span>
          <span
            class="tag is-link is-medium is-rounded cursor"
            @click="$router.push('/kunst-kultur')"
          >Kunst & Kultur</span>
          <span
            class="tag is-link is-medium is-rounded cursor"
            @click="$router.push('/museen')"
          >Museen</span>
          <span
            class="tag is-link is-medium is-rounded cursor"
            @click="$router.push('/sport')"
          >Sport</span>
          <span
            class="tag is-link is-medium is-rounded cursor"
            @click="$router.push('/stifte-kloester-schloesser')"
          >Stifte, Klöster & Schlösser</span>
          <span
            class="tag is-link is-medium is-rounded cursor"
            @click="$router.push('/stories')"
          >Stories</span>
          <span
            class="tag is-link is-medium is-rounded cursor"
            @click="$router.push('/unterkuenfte')"
          >Unterkünfte</span>
          <span
            class="tag is-link is-medium is-rounded cursor"
            @click="$router.push('/veranstaltungen')"
          >Veranstaltungen</span>
          <span
            class="tag is-link is-medium is-rounded cursor"
            @click="$router.push('/wellness')"
          >Wellness</span>
        </div>
      </div>

      <div class="column is-4" v-if="cookies_facebook">
        <p class="title">Folgen Sie uns</p>
        <div
          class="fb-page"
          data-width="500"
          data-height="300"
          data-href="https://www.facebook.com/urlaubimwaldviertel.at/"
          data-tabs="timeline"
          data-small-header="true"
          data-adapt-container-width="true"
          data-hide-cover="false"
          data-show-facepile="true"
        >
          <blockquote
            cite="https://www.facebook.com/urlaubimwaldviertel.at/"
            class="fb-xfbml-parse-ignore"
          >
            <a href="https://www.facebook.com/urlaubimwaldviertel.at/">Urlaub im Waldviertel</a>
          </blockquote>
        </div>
      </div>

      <div class="column is-12 is-size-7">
        <p><router-link to="/impressum">Impressum</router-link></p>
        <p><a @click="$store.commit('editCookies')">Datenschutzeinstellungen</a></p>
        <p>© urlaubimwaldviertel.at</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
    computed: {
    // define getters
    cookies_facebook() {
      return this.$store.getters.cookies_facebook
    },
    }
}
</script>

<style>
</style>
